<template>
  <div class="section-container section-white">
    <div class="section-title">医疗器械供应链数字化的"三步走战略"</div>
    <div class="timeline-strategy">
      <div class="tree-content">
        <img src="@/assets/img/tree.jpg" alt="科室树形图" class="tree-image" />
      </div>

      <div class="timeline-right">
        <div class="step-container">
          <div class="step-item step1">
            <div class="step-number">Step1</div>
            <div class="step-title">骨科切入</div>
            <div class="step-desc">通过让尽可能多的经销商实现数字化，也让厂商具备更强的渠道管理能力。首先选择从难度最大的骨科开始切入。</div>
          </div>

          <div class="step-item step2">
            <div class="step-number">Step2</div>
            <div class="step-title">多科室延伸</div>
            <div class="step-desc">通过经销商环节的数字化能力反向推动厂商和医院端的全面智能化，实现真正意义上的销售拉动型生产配置能力。</div>
          </div>

          <div class="step-item step3">
            <div class="step-number">Step3</div>
            <div class="step-title">全链路智能化</div>
            <div class="step-desc">科室横向延伸，通过融合不同的科室，实现特色化的专业科室服务能力。</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TimelineStrategy'
}
</script>

<style lang="scss" scoped>
.section-container {
  padding: 40PX 0;
}

.timeline-strategy {
  max-width: 1200PX;
  margin: 0 auto;
  padding: 0 $spacing-sm;
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  position: relative;
  gap: 60PX;
}

.tree-content {
  flex: 1;
  padding-right: 0;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  position: relative;
}

.tree-image {
  max-width: 100%;
  height: auto;
  object-fit: contain;
  margin-top: 30PX;
}

.timeline-right {
  width: 450PX;
  position: relative;
}

.step-container {
  position: relative;
  height: 600PX;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 40PX 0 40PX 30PX;
}

.step-item {
  position: relative;
  padding: 20PX 0;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  
  &::before {
    content: '';
    position: absolute;
    left: -36PX;
    top: 28PX;
    width: 18PX;
    height: 18PX;
    background: #fff;
    border: 4PX solid #1890ff;
    border-radius: 50%;
    box-shadow: 0 0 0 4PX rgba(24, 144, 255, 0.2);
    transition: all 0.3s ease;
  }

  &::after {
    content: '';
    position: absolute;
    left: -18PX;
    top: 36PX;
    width: 60PX;
    height: 2PX;
    background: linear-gradient(90deg, #1890ff, rgba(24, 144, 255, 0.2));
  }

  &:hover {
    transform: translateX(10PX);

    &::before {
      background: #1890ff;
      transform: scale(1.2);
    }

    &::after {
      transform: translateX(5PX);
    }

    .step-number {
      color: #1890ff;
      transform: translateX(5PX);
    }
  }

  &.step1, &.step3 { 
    margin-left: 0;
  }
  &.step2 { 
    margin-left: 60PX;
  }

  .step-number {
    color: #1890ff;
    font-size: 22PX;
    font-weight: bold;
    margin-bottom: 10PX;
    transition: all 0.3s ease;
    display: inline-block;
    line-height: 1;
    margin-left: 50PX;
  }

  .step-title {
    color: #333333;
    font-size: 20PX;
    font-weight: bold;
    margin-bottom: 12PX;
    margin-left: 50PX;
  }

  .step-desc {
    color: #666666;
    font-size: 15PX;
    line-height: 1.6;
    padding-right: 20PX;
    margin-left: 50PX;
    text-align: left;
  }
}

@media screen and (max-width: $screen-md) {
  .timeline-strategy {
    flex-direction: column;
    padding: $spacing-md;
    gap: $spacing-md;
  }

  .tree-content {
    padding-right: 0;
    margin-top: 0;
  }

  .timeline-right {
    width: 100%;
    padding: 0;
  }

  .step-container {
    height: auto;
    padding: 40PX 0 40PX 25PX;
    margin: 0;
  }

  .step-item {
    margin-bottom: 40PX;
    margin-left: 0 !important;
    padding: 15PX 0;

    &:hover {
      transform: translateX(10PX);
    }

    &::before {
      left: -31PX;
      top: 24PX;
    }

    &::after {
      left: -13PX;
      top: 32PX;
      width: 40PX;
    }

    .step-number,
    .step-title,
    .step-desc {
      margin-left: 30PX;
    }

    .step-desc {
      padding-right: 0;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }

  .section-title {
    font-size: 24PX;
    margin-bottom: 40PX;
    padding: $spacing-sm 0;
  }
}
</style>